import { Select } from '@framework/ui';

import { Typography } from 'antd';
import React from 'react';

import { useTranslation } from '@framework/i18n';
import { ExportFileField } from './ExportFileTypes';
import { useExportFileFieldSelectOptions } from './useExportFileFieldSelectOptions';

interface ExportFileFieldSelectProps {
  fields: ExportFileField[] | null | undefined;
  isLoading: boolean;
  selected: string[];
  onSelect: (fields: string[]) => void;
}

export function ExportFieldFieldsSelect(props: ExportFileFieldSelectProps) {
  const { fields, isLoading, onSelect, selected } = props;

  const { t } = useTranslation();
  const options = useExportFileFieldSelectOptions(fields);

  return (
    <>
      <Typography.Paragraph>
        {t(
          'export-field-select.select-fields-to-export-title',
          "Seleziona i campi da esportare. Se non indichi nessun campo, l'esportazione conterrà tutti i dati.",
        )}
      </Typography.Paragraph>
      <Select
        mode={'multiple'}
        style={{ width: '100%' }}
        placeholder={t(
          'export-field-select.select-fields-to-export',
          'Seleziona i campi da esportare',
        )}
        loading={isLoading}
        options={options}
        onChange={onSelect}
        defaultValue={selected}
        value={selected}
        optionFilterProp={'label'}
      />
    </>
  );
}
